<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Tambah Verifikator Baru</strong>
        </h5>
        <a-form :form="form"  @submit="handleSubmit">
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Nama Lengkap">
            <a-input
              :disabled="submitting"
              placeholder="Masukkan Nama Lengkap Verifikator"
              v-decorator="['fullname', {rules: [{ required: true, message: 'Nama verifikator harus diisi!' }]}]"
            />
          </a-form-item>
          <!-- <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Tanggal Lahir">
            <a-input
              :disabled="submitting"
              placeholder="Tanggal Lahir"
              v-decorator="['dateOfBirth', {rules: [{ required: true, message: 'Tanggal Lahir harus diisi!' }]}]"
            />
          </a-form-item> -->
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Alamat E-mail">
            <a-input
              :disabled="submitting"
              placeholder="Alamat E-mail"
              v-decorator="['email', {rules: [{ required: true, message: 'E-mail harus diisi!' }]}]"
            />
          </a-form-item>
          <!-- <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Rumah Sakit">
            <a-input
              :disabled="submitting"
              placeholder="Rumah Sakit"programTypeName
              v-decorator="['hospital', {rules: [{ required: true, message: 'Nama rumah sakit harus diisi!' }]}]"
            />
          </a-form-item> -->
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Program">
            <a-select
              :disabled="submitting"
              v-decorator="[
                'programTypeName',
                { rules: [{ required: true, message: 'Program harus diisi!' }] },
              ]"
              placeholder="Program"
            >
              <a-select-option value="TAGRISSO">
                  TAGRISSO
               </a-select-option>
               <a-select-option value="FASLODEX">
                  FASLODEX
               </a-select-option>
               <a-select-option value="LYNPARZA">
                  LYNPARZA
               </a-select-option>
               <a-select-option value="aurora">
                  Aurora
               </a-select-option>
            </a-select>
          </a-form-item>
          <button type="submit" class="btn btn-success px-5" :disabled="submitting">Simpan Data</button>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>

import router from '@/router'
import { create } from '@/services/axios/api/verifikator'
import { getAll } from '@/services/axios/api/city'
import { notification } from 'ant-design-vue'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      submitting: false,
    }
  },
  created() {
    this.getCityList()
  },
  methods: {
    async getCityList() {
      const res = await getAll()
      this.cityList = res
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            const res = await create(values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil ditambahkan',
                duration: 5,
              })
              router.push('/verifikator')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
  },
}
</script>
